import { getMeasure } from '../performance';
import { SmartLinkActionType } from '@atlaskit/linking-types';
export const ANALYTICS_CHANNEL = 'media';
export const context = {
  componentName: 'smart-cards',
  packageName: "@atlaskit/smart-card",
  packageVersion: "28.4.0"
};
export let TrackQuickActionType = /*#__PURE__*/function (TrackQuickActionType) {
  TrackQuickActionType["StatusUpdate"] = "StatusUpdate";
  return TrackQuickActionType;
}({});
export let TrackQuickActionFailureReason = /*#__PURE__*/function (TrackQuickActionFailureReason) {
  TrackQuickActionFailureReason["PermissionError"] = "PermissionError";
  TrackQuickActionFailureReason["ValidationError"] = "ValidationError";
  TrackQuickActionFailureReason["UnknownError"] = "UnknownError";
  return TrackQuickActionFailureReason;
}({});
export const SmartLinkActionTypeTrackingEventMapper = {
  [SmartLinkActionType.FollowEntityAction]: 'Follow',
  [SmartLinkActionType.StatusUpdateAction]: 'StatusUpdate',
  [SmartLinkActionType.UnfollowEntityAction]: 'Unfollow'
};
export const SmartLinkActionTypeUiEventMapper = {
  [SmartLinkActionType.FollowEntityAction]: 'smartLinkFollowButton',
  [SmartLinkActionType.UnfollowEntityAction]: 'smartLinkFollowButton'
};
const uiActionSubjectIds = {
  DownloadAction: 'downloadDocument',
  PreviewAction: 'invokePreviewScreen',
  ViewAction: 'shortcutGoToLink',
  StatusAction: 'issueStatusUpdate'
};
export class SmartLinkEvents {
  insertSmartLink(url, type, createAnalyticsEvent) {
    fireSmartLinkEvent({
      action: 'inserted',
      actionSubject: 'smartLink',
      eventType: 'track',
      attributes: {
        type
      },
      nonPrivacySafeAttributes: {
        domainName: url
      }
    }, createAnalyticsEvent);
  }
}
export const fireSmartLinkEvent = (payload, createAnalyticsEvent) => {
  if (createAnalyticsEvent) {
    createAnalyticsEvent(payload).fire(ANALYTICS_CHANNEL);
  }
};
export const resolvedEvent = props => ({
  action: 'resolved',
  actionSubject: 'smartLink',
  eventType: 'operational',
  attributes: {
    ...props,
    ...context
  }
});
export const unresolvedEvent = ({
  id,
  definitionId,
  extensionKey,
  resourceType,
  destinationSubproduct,
  destinationProduct,
  error,
  status,
  location
}) => ({
  action: 'unresolved',
  actionSubject: 'smartLink',
  eventType: 'operational',
  attributes: {
    id,
    ...context,
    ...(definitionId ? {
      definitionId
    } : {}),
    ...(extensionKey ? {
      extensionKey
    } : {}),
    ...(resourceType ? {
      resourceType
    } : {}),
    ...(destinationSubproduct ? {
      destinationSubproduct
    } : {}),
    ...(destinationProduct ? {
      destinationProduct
    } : {}),
    ...(location ? {
      location
    } : {}),
    reason: status,
    error: error ? {
      message: error === null || error === void 0 ? void 0 : error.message,
      kind: error === null || error === void 0 ? void 0 : error.kind,
      type: error === null || error === void 0 ? void 0 : error.type
    } : undefined
  }
});
export const invokeSucceededEvent = ({
  id,
  actionType,
  display,
  extensionKey,
  definitionId,
  destinationProduct,
  destinationSubproduct,
  location
}) => {
  const measure = id ? getMeasure(id, 'resolved') : undefined;
  return {
    action: 'resolved',
    actionSubject: 'smartLinkAction',
    eventType: 'operational',
    attributes: {
      ...context,
      id,
      actionType,
      display,
      definitionId,
      destinationProduct,
      destinationSubproduct,
      location,
      extensionKey,
      duration: measure === null || measure === void 0 ? void 0 : measure.duration
    }
  };
};
export const invokeFailedEvent = ({
  id,
  actionType,
  display,
  reason,
  extensionKey,
  definitionId,
  destinationProduct,
  destinationSubproduct,
  location
}) => {
  const measure = id ? getMeasure(id, 'errored') : undefined;
  return {
    action: 'unresolved',
    actionSubject: 'smartLinkAction',
    eventType: 'operational',
    attributes: {
      ...context,
      id,
      actionType,
      display,
      extensionKey,
      definitionId,
      destinationProduct,
      destinationSubproduct,
      location,
      duration: measure === null || measure === void 0 ? void 0 : measure.duration,
      reason
    }
  };
};
export const connectSucceededEvent = ({
  definitionId,
  extensionKey,
  destinationProduct,
  destinationSubproduct,
  location
}) => ({
  action: 'connectSucceeded',
  actionSubject: 'smartLink',
  eventType: 'operational',
  attributes: {
    ...context,
    definitionId,
    extensionKey,
    destinationProduct,
    destinationSubproduct,
    location
  }
});
export const connectFailedEvent = ({
  definitionId,
  extensionKey,
  destinationProduct,
  destinationSubproduct,
  location,
  reason
}) => ({
  action: 'connectFailed',
  actionSubject: 'smartLink',
  actionSubjectId: reason,
  eventType: 'operational',
  attributes: {
    ...context,
    reason,
    extensionKey,
    definitionId,
    destinationProduct,
    destinationSubproduct,
    location
  }
});
export const trackAppAccountConnected = ({
  definitionId,
  extensionKey,
  destinationProduct,
  destinationSubproduct,
  location
}) => ({
  action: 'connected',
  actionSubject: 'applicationAccount',
  eventType: 'track',
  attributes: {
    ...context,
    definitionId,
    extensionKey,
    destinationProduct,
    destinationSubproduct,
    location
  }
});
export const trackAppAccountAuthStarted = ({
  extensionKey,
  location
}) => ({
  action: 'authStarted',
  actionSubject: 'applicationAccount',
  eventType: 'track',
  attributes: {
    ...context,
    extensionKey,
    location
  }
});
export const trackSmartLinkQuickActionStarted = ({
  smartLinkActionType,
  ...attributes
}) => {
  var _SmartLinkActionTypeT;
  return {
    action: 'started',
    actionSubject: 'smartLinkQuickAction',
    eventType: 'track',
    attributes: {
      ...context,
      ...attributes,
      smartLinkActionType: (_SmartLinkActionTypeT = SmartLinkActionTypeTrackingEventMapper[smartLinkActionType]) !== null && _SmartLinkActionTypeT !== void 0 ? _SmartLinkActionTypeT : smartLinkActionType
    }
  };
};
export const trackSmartLinkQuickActionSuccess = ({
  smartLinkActionType,
  ...attributes
}) => {
  var _SmartLinkActionTypeT2;
  return {
    action: 'success',
    actionSubject: 'smartLinkQuickAction',
    eventType: 'track',
    attributes: {
      ...context,
      ...attributes,
      smartLinkActionType: (_SmartLinkActionTypeT2 = SmartLinkActionTypeTrackingEventMapper[smartLinkActionType]) !== null && _SmartLinkActionTypeT2 !== void 0 ? _SmartLinkActionTypeT2 : smartLinkActionType
    }
  };
};
export const trackSmartLinkQuickActionFailed = ({
  smartLinkActionType,
  ...attributes
}) => {
  var _SmartLinkActionTypeT3;
  return {
    action: 'failed',
    actionSubject: 'smartLinkQuickAction',
    eventType: 'track',
    attributes: {
      ...context,
      ...attributes,
      smartLinkActionType: (_SmartLinkActionTypeT3 = SmartLinkActionTypeTrackingEventMapper[smartLinkActionType]) !== null && _SmartLinkActionTypeT3 !== void 0 ? _SmartLinkActionTypeT3 : smartLinkActionType
    }
  };
};
export const trackHoverCardResolutionStarted = ({
  display,
  ...attributes
}) => ({
  action: 'resolved',
  actionSubject: 'hoverCard',
  eventType: 'track',
  attributes: {
    ...context,
    ...attributes,
    display
  }
});
export const uiAuthEvent = ({
  definitionId,
  extensionKey,
  destinationProduct,
  destinationSubproduct,
  location,
  display
}) => ({
  action: 'clicked',
  actionSubject: 'button',
  actionSubjectId: 'connectAccount',
  eventType: 'ui',
  attributes: {
    ...context,
    definitionId,
    extensionKey,
    destinationProduct,
    destinationSubproduct,
    location,
    display
  }
});
export const uiAuthAlternateAccountEvent = ({
  definitionId,
  extensionKey,
  destinationProduct,
  destinationSubproduct,
  location,
  display
}) => ({
  action: 'clicked',
  actionSubject: 'smartLink',
  actionSubjectId: 'tryAnotherAccount',
  eventType: 'ui',
  attributes: {
    ...context,
    definitionId,
    extensionKey,
    destinationProduct,
    destinationSubproduct,
    location,
    display
  }
});
export const uiCardClickedEvent = ({
  id,
  display,
  status,
  definitionId,
  extensionKey,
  isModifierKeyPressed,
  location,
  destinationProduct,
  destinationSubproduct,
  actionSubjectId
}) => ({
  action: 'clicked',
  actionSubject: 'smartLink',
  actionSubjectId,
  eventType: 'ui',
  attributes: {
    ...context,
    id,
    status,
    definitionId,
    extensionKey,
    display,
    isModifierKeyPressed,
    location,
    destinationProduct,
    destinationSubproduct
  }
});
export const uiIframeDwelledEvent = ({
  id,
  display,
  status,
  definitionId,
  extensionKey,
  location,
  destinationProduct,
  destinationSubproduct,
  dwellTime,
  dwellPercentVisible
}) => ({
  action: 'dwelled',
  actionSubject: 'smartLinkIframe',
  eventType: 'ui',
  attributes: {
    ...context,
    id,
    status,
    definitionId,
    extensionKey,
    display,
    location,
    destinationProduct,
    destinationSubproduct,
    dwellTime,
    dwellPercentVisible
  }
});
export const uiIframeFocusedEvent = ({
  id,
  display,
  status,
  definitionId,
  extensionKey,
  location,
  destinationProduct,
  destinationSubproduct
}) => ({
  action: 'focused',
  actionSubject: 'smartLinkIframe',
  eventType: 'ui',
  attributes: {
    ...context,
    id,
    status,
    definitionId,
    extensionKey,
    display,
    location,
    destinationProduct,
    destinationSubproduct
  }
});
export const uiActionClickedEvent = ({
  id,
  actionType,
  extensionKey,
  display,
  definitionId,
  destinationProduct,
  destinationSubproduct,
  location
}) => ({
  action: 'clicked',
  actionSubject: 'button',
  actionSubjectId: uiActionSubjectIds[actionType],
  eventType: 'ui',
  attributes: {
    ...context,
    id,
    display,
    actionType: actionType,
    extensionKey: extensionKey,
    definitionId,
    destinationProduct,
    destinationSubproduct,
    location
  }
});
export const uiClosedAuthEvent = ({
  display,
  extensionKey,
  definitionId,
  destinationProduct,
  destinationSubproduct,
  location
}) => ({
  action: 'closed',
  actionSubject: 'consentModal',
  eventType: 'ui',
  attributes: {
    ...context,
    extensionKey,
    definitionId,
    destinationProduct,
    destinationSubproduct,
    location,
    display
  }
});
export const screenAuthPopupEvent = ({
  extensionKey,
  definitionId,
  destinationProduct,
  destinationSubproduct,
  location
}) => ({
  actionSubject: 'consentModal',
  eventType: 'screen',
  attributes: {
    ...context,
    extensionKey,
    definitionId,
    destinationProduct,
    destinationSubproduct,
    location
  }
});
export const uiRenderSuccessEvent = ({
  display,
  status,
  extensionKey,
  definitionId,
  destinationProduct,
  destinationSubproduct,
  location,
  canBeDatasource
}) => ({
  action: 'renderSuccess',
  actionSubject: 'smartLink',
  eventType: 'ui',
  attributes: {
    ...context,
    status,
    extensionKey,
    definitionId,
    destinationProduct,
    destinationSubproduct,
    location,
    display,
    canBeDatasource
  }
});
export const uiRenderFailedEvent = ({
  display,
  error,
  errorInfo,
  extensionKey,
  definitionId,
  destinationProduct,
  destinationSubproduct,
  location
}) => ({
  actionSubject: 'smartLink',
  action: 'renderFailed',
  eventType: 'ui',
  attributes: {
    ...context,
    error,
    errorInfo,
    display,
    extensionKey,
    definitionId,
    destinationProduct,
    destinationSubproduct,
    location
  }
});
export const uiHoverCardViewedEvent = ({
  id,
  previewDisplay,
  extensionKey,
  definitionId,
  destinationProduct,
  destinationSubproduct,
  location,
  previewInvokeMethod,
  status
}) => ({
  action: 'viewed',
  actionSubject: 'hoverCard',
  eventType: 'ui',
  attributes: {
    ...context,
    id,
    previewDisplay,
    extensionKey,
    definitionId,
    destinationProduct,
    destinationSubproduct,
    location,
    previewInvokeMethod,
    status
  }
});
export const uiHoverCardDismissedEvent = ({
  id,
  previewDisplay,
  hoverTime,
  extensionKey,
  definitionId,
  destinationProduct,
  destinationSubproduct,
  location,
  previewInvokeMethod,
  status
}) => ({
  action: 'dismissed',
  actionSubject: 'hoverCard',
  eventType: 'ui',
  attributes: {
    ...context,
    id,
    previewDisplay,
    hoverTime,
    extensionKey,
    definitionId,
    destinationProduct,
    destinationSubproduct,
    location,
    previewInvokeMethod,
    status
  }
});
export const uiHoverCardOpenLinkClickedEvent = ({
  id,
  previewDisplay,
  extensionKey,
  definitionId,
  destinationProduct,
  destinationSubproduct,
  location,
  previewInvokeMethod
}) => ({
  action: 'clicked',
  actionSubject: 'button',
  actionSubjectId: 'shortcutGoToLink',
  eventType: 'ui',
  attributes: {
    ...context,
    id,
    previewDisplay,
    extensionKey,
    definitionId,
    destinationProduct,
    destinationSubproduct,
    location,
    previewInvokeMethod
  }
});
export const uiLearnMoreLinkClickedEvent = () => ({
  action: 'clicked',
  actionSubject: 'button',
  actionSubjectId: 'learnMore',
  eventType: 'ui',
  attributes: {
    ...context
  }
});
export const chunkloadFailedEvent = ({
  display,
  error,
  errorInfo,
  extensionKey,
  definitionId,
  destinationProduct,
  destinationSubproduct,
  location
}) => ({
  action: 'chunkLoadFailed',
  actionSubject: 'smartLink',
  eventType: 'operational',
  attributes: {
    ...context,
    error,
    errorInfo,
    display,
    extensionKey,
    definitionId,
    destinationProduct,
    destinationSubproduct,
    location
  }
});
export const uiSmartLinkStatusLozengeButtonClicked = () => ({
  action: 'clicked',
  actionSubject: 'button',
  actionSubjectId: 'smartLinkStatusLozenge',
  eventType: 'ui',
  attributes: {
    ...context
  }
});
export const uiSmartLinkStatusListItemButtonClicked = () => ({
  action: 'clicked',
  actionSubject: 'button',
  actionSubjectId: 'smartLinkStatusListItem',
  eventType: 'ui',
  attributes: {
    ...context
  }
});
export const uiSmartLinkStatusOpenPreviewButtonClicked = () => ({
  action: 'clicked',
  actionSubject: 'button',
  actionSubjectId: 'smartLinkStatusOpenPreview',
  eventType: 'ui',
  attributes: {
    ...context
  }
});
export const uiServerActionClicked = ({
  smartLinkActionType
}) => {
  var _SmartLinkActionTypeU;
  return {
    action: 'clicked',
    actionSubject: 'button',
    actionSubjectId: (_SmartLinkActionTypeU = SmartLinkActionTypeUiEventMapper[smartLinkActionType]) !== null && _SmartLinkActionTypeU !== void 0 ? _SmartLinkActionTypeU : smartLinkActionType,
    eventType: 'ui',
    attributes: {
      ...context
    }
  };
};